import { I18nService, trimArray, instanceOfReference } from "@perxis-auto/shared";
import { APP } from "../../../../shared/config/app.js";
import "../../../../shared/config/env.js";
import "../../../../shared/config/events.js";
import "react";
import "@perxis-auto/shared/lib";
import "../../../../shared/lib/constructor/mergeConstructor.js";
import "react/jsx-runtime";
import "@perxis-auto/ui-kit";
import { formatVehicleBrandImage } from "../../../../shared/lib/format/vehicle/formatVehicleBrandImage.js";
import { ConstructorWidgetEnum } from "../../../../shared/types/constructor/widget.js";
import { formatVehicleModelImage } from "../../../../shared/lib/format/vehicle/formatVehicleModelImage.js";
import "../../../../shared/lib/logger/index.js";
import "react-router";
import "@perxis-auto/shared/lib/lib/is/isObject";
import "../../../../shared/lib/store/createAppApi.js";
import "../../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../../shared/lib/store/createAppSelector.js";
import "../../../../shared/lib/store/createAppSlice.js";
import "redux";
import "../../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../../shared/lib/store/hooks/useAppStore.js";
import { FilterLocationEnum } from "../../types/values.js";
import { instanceOfFilterPrimitive } from "../instanceOf/instanceOfFilterPrimitive.js";
import { instanceOfFilterRange } from "../instanceOf/instanceOfFilterRange.js";
import { sortCheckboxOptions } from "../sort/sortCheckboxOptions.js";
import { sortSelectOptions } from "../sort/sortSelectOptions.js";
const optionLabelFormatter = (filterValue) => {
  const { i18n } = I18nService.getInstance();
  if (instanceOfReference(filterValue)) {
    let label = filterValue.displayName ?? filterValue.name ?? null;
    if ("color" in filterValue) {
      const filterColorValue = filterValue;
      label = label ? `${label}${!!filterColorValue.additionalColorName && !!filterColorValue.additionalColor ? ` / ${filterColorValue.additionalColorName}` : ""}` : null;
    }
    if ("specification" in filterValue) {
      const filterSpecificationValue = filterValue;
      let specificationLabel = null;
      if (typeof filterSpecificationValue.stringValue === "string") {
        specificationLabel = filterSpecificationValue.stringValue;
      }
      if (typeof filterSpecificationValue.numberValue === "number") {
        specificationLabel = String(filterSpecificationValue.numberValue);
      }
      if (typeof filterSpecificationValue.booleanValue === "boolean") {
        specificationLabel = filterSpecificationValue.booleanValue ? i18n.t("common.booleanValues.trueValue", { ns: APP.name }) : i18n.t("common.booleanValues.falseValue", { ns: APP.name });
      }
      label ?? (label = specificationLabel);
    }
    return label || "";
  }
  if (instanceOfFilterPrimitive(filterValue)) {
    if (typeof filterValue.displayName !== "undefined") {
      return filterValue.displayName;
    }
    if (typeof filterValue.value === "boolean") {
      return filterValue.value ? i18n.t("common.booleanValues.trueValue", { ns: APP.name }) : i18n.t("common.booleanValues.falseValue", { ns: APP.name });
    }
    return String(filterValue.value);
  }
  return "";
};
const optionFormatterMap = {
  [ConstructorWidgetEnum.FilterSelect](filterValue) {
    const label = optionLabelFormatter(filterValue);
    if (instanceOfReference(filterValue)) {
      return {
        label,
        value: filterValue.id,
        disabled: !filterValue.available,
        order: filterValue.position
      };
    }
    if (instanceOfFilterPrimitive(filterValue)) {
      return {
        label,
        value: filterValue.value,
        disabled: !filterValue.available
      };
    }
  },
  [ConstructorWidgetEnum.FilterMultipleSelect](filterValue) {
    const label = optionLabelFormatter(filterValue);
    if (instanceOfReference(filterValue)) {
      return {
        label,
        value: filterValue.id,
        disabled: !filterValue.available,
        order: filterValue.position
      };
    }
    if (instanceOfFilterPrimitive(filterValue)) {
      return {
        label,
        value: filterValue.value,
        disabled: !filterValue.available
      };
    }
  },
  [ConstructorWidgetEnum.FilterLocation](filterValue) {
    var _a;
    const label = optionLabelFormatter(filterValue);
    if (instanceOfReference(filterValue)) {
      const filterLocationValue = filterValue;
      return {
        label,
        value: filterLocationValue.id,
        disabled: !filterLocationValue.available,
        order: filterLocationValue.type === FilterLocationEnum.Cluster ? (filterLocationValue.position || 0) - 1e3 : filterLocationValue.position,
        type: filterLocationValue.type ?? FilterLocationEnum.City,
        clusterId: (_a = filterLocationValue == null ? void 0 : filterLocationValue.cluster) == null ? void 0 : _a.id
      };
    }
  },
  [ConstructorWidgetEnum.FilterCheckboxGroup](filterValue) {
    const label = optionLabelFormatter(filterValue);
    if (instanceOfReference(filterValue)) {
      return {
        label,
        value: filterValue.id,
        disabled: !filterValue.available,
        order: filterValue.position
      };
    }
    if (instanceOfFilterPrimitive(filterValue)) {
      return {
        label,
        value: filterValue.value,
        disabled: !filterValue.available
      };
    }
  },
  [ConstructorWidgetEnum.FilterModels](filterValue, config) {
    var _a, _b;
    const label = optionLabelFormatter(filterValue);
    if (instanceOfReference(filterValue)) {
      const { i18n } = I18nService.getInstance();
      const filterModelValue = filterValue;
      const price = filterModelValue.price ? filterModelValue.price : filterModelValue.marketingPrice;
      const modelImage = (filterModelValue == null ? void 0 : filterModelValue.marketingMedia) ? formatVehicleModelImage(filterModelValue.marketingMedia, { media: config.media }) : null;
      const brandName = ((_a = filterModelValue.extendedBrand) == null ? void 0 : _a.displayName) || ((_b = filterModelValue.extendedBrand) == null ? void 0 : _b.name);
      const brandImage = (filterModelValue == null ? void 0 : filterModelValue.brandMedia) ? formatVehicleBrandImage(filterModelValue.brandMedia, { media: config.media }) : null;
      return {
        label,
        value: filterModelValue.id,
        disabled: !filterModelValue.available,
        order: filterModelValue.position,
        model: {
          name: label,
          description: filterModelValue.marketingPositioning,
          price: price ? `${i18n.t("config.modelCheckbox.from", { ns: APP.name })} ${i18n.t("format.currency", { value: price, ns: APP.name })}` : void 0,
          imgAlt: filterModelValue.name,
          imgSrc: modelImage == null ? void 0 : modelImage.original,
          imgSizes: modelImage == null ? void 0 : modelImage.sizes,
          imgSrcSet: modelImage == null ? void 0 : modelImage.srcSet
        },
        brand: filterModelValue.extendedBrand ? {
          id: filterModelValue.extendedBrand.id,
          title: brandName,
          position: filterModelValue.extendedBrand.position,
          description: filterModelValue.brandPositioning,
          imgSrc: brandImage == null ? void 0 : brandImage.original,
          imgAlt: brandName
        } : void 0
      };
    }
  },
  [ConstructorWidgetEnum.FilterColorPicker](filterValue) {
    const label = optionLabelFormatter(filterValue);
    if (instanceOfReference(filterValue)) {
      const filterColorValue = filterValue;
      return {
        label,
        value: filterColorValue.id,
        color: filterColorValue.color,
        disabled: !filterColorValue.available,
        order: filterColorValue.position
      };
    }
  },
  [ConstructorWidgetEnum.FilterDuoColorPicker](record) {
    const label = optionLabelFormatter(record);
    if (instanceOfReference(record)) {
      const filterColorValue = record;
      return {
        label,
        value: filterColorValue.id,
        color: filterColorValue.color,
        additionalColor: filterColorValue.additionalColor ? filterColorValue.additionalColor : null,
        disabled: !filterColorValue.available,
        order: filterColorValue.position
      };
    }
  },
  [ConstructorWidgetEnum.FilterOptions](record) {
    const label = optionLabelFormatter(record);
    if (instanceOfReference(record)) {
      const filterPackageOptionValue = record;
      return {
        label,
        value: filterPackageOptionValue.id,
        disabled: !filterPackageOptionValue.available,
        order: filterPackageOptionValue.position,
        group: filterPackageOptionValue.group
      };
    }
  }
};
const prepareFilterItemProps = ({ type, filterValues, props }, config) => {
  const { i18n } = I18nService.getInstance();
  const preparedProps = { ...props };
  const filterDisabledOptions = (option) => {
    return !option.disabled;
  };
  switch (type) {
    case ConstructorWidgetEnum.FilterLocation:
    case ConstructorWidgetEnum.FilterSelect:
    case ConstructorWidgetEnum.FilterMultipleSelect: {
      if (!(preparedProps == null ? void 0 : preparedProps.options) && !!filterValues) {
        const resolvedValues = [filterValues].flat();
        Object.assign(preparedProps, {
          options: trimArray(resolvedValues.map((value) => {
            var _a;
            return (_a = optionFormatterMap[type]) == null ? void 0 : _a.call(optionFormatterMap, value, config);
          }))
        });
      }
      if (Array.isArray(preparedProps.options) && !!(preparedProps == null ? void 0 : preparedProps.optionFormatter)) {
        const optionFormatter = preparedProps.optionFormatter;
        Object.assign(preparedProps, {
          options: trimArray(preparedProps.options.map(optionFormatter))
        });
        delete preparedProps.optionFormatter;
      }
      if (Array.isArray(preparedProps.options) && !!(preparedProps == null ? void 0 : preparedProps.optionLabelFormatter)) {
        const optionLabelFormatter2 = preparedProps.optionLabelFormatter;
        Object.assign(preparedProps, {
          options: preparedProps.options.map((option) => ({
            ...option,
            label: optionLabelFormatter2(option)
          }))
        });
        delete preparedProps.optionLabelFormatter;
      }
      if (Array.isArray(preparedProps.options) && !!(preparedProps == null ? void 0 : preparedProps.hideDisabledOptions)) {
        Object.assign(preparedProps, {
          options: preparedProps.options.filter(filterDisabledOptions)
        });
        delete preparedProps.hideDisabledOptions;
      }
      return {
        placeholder: i18n.t("config.select.placeholder", { ns: APP.name }),
        filterSort: sortSelectOptions,
        ...preparedProps
      };
    }
    case ConstructorWidgetEnum.FilterCheckboxGroup:
    case ConstructorWidgetEnum.FilterModels:
    case ConstructorWidgetEnum.FilterColorPicker:
    case ConstructorWidgetEnum.FilterDuoColorPicker:
    case ConstructorWidgetEnum.FilterOptions: {
      if (!(preparedProps == null ? void 0 : preparedProps.options) && !!filterValues) {
        const resolvedValues = [filterValues].flat();
        Object.assign(preparedProps, {
          options: trimArray(resolvedValues.map((value) => {
            var _a;
            return (_a = optionFormatterMap[type]) == null ? void 0 : _a.call(optionFormatterMap, value, config);
          }))
        });
      }
      if (Array.isArray(preparedProps.options) && !!(preparedProps == null ? void 0 : preparedProps.optionFormatter)) {
        const optionFormatter = preparedProps.optionFormatter;
        Object.assign(preparedProps, {
          options: trimArray(preparedProps.options.map(optionFormatter))
        });
        delete preparedProps.optionFormatter;
      }
      if (Array.isArray(preparedProps.options) && !!(preparedProps == null ? void 0 : preparedProps.optionLabelFormatter)) {
        const optionLabelFormatter2 = preparedProps.optionLabelFormatter;
        Object.assign(preparedProps, {
          options: preparedProps.options.map((option) => ({
            ...option,
            label: optionLabelFormatter2(option)
          }))
        });
        delete preparedProps.optionLabelFormatter;
      }
      if (Array.isArray(preparedProps.options)) {
        const filterSort = preparedProps.filterSort || sortCheckboxOptions;
        Object.assign(preparedProps, {
          options: preparedProps.options.sort(filterSort)
        });
        delete preparedProps.filterSort;
      }
      if (Array.isArray(preparedProps.options) && !!(preparedProps == null ? void 0 : preparedProps.hideDisabledOptions)) {
        Object.assign(preparedProps, {
          options: preparedProps.options.filter(filterDisabledOptions)
        });
        delete preparedProps.hideDisabledOptions;
      }
      return preparedProps;
    }
    case ConstructorWidgetEnum.FilterSlider: {
      if (!(preparedProps == null ? void 0 : preparedProps.min) || !preparedProps.max) {
        if (instanceOfFilterRange(filterValues)) {
          Object.assign(preparedProps, {
            min: (preparedProps == null ? void 0 : preparedProps.min) || (filterValues == null ? void 0 : filterValues.min),
            max: (preparedProps == null ? void 0 : preparedProps.max) || (filterValues == null ? void 0 : filterValues.max)
          });
        }
      }
      return preparedProps;
    }
    case ConstructorWidgetEnum.FilterRangeSlider: {
      if (!(preparedProps == null ? void 0 : preparedProps.min) || !preparedProps.max) {
        if (instanceOfFilterRange(filterValues)) {
          Object.assign(preparedProps, {
            min: (preparedProps == null ? void 0 : preparedProps.min) || (filterValues == null ? void 0 : filterValues.min),
            max: (preparedProps == null ? void 0 : preparedProps.max) || (filterValues == null ? void 0 : filterValues.max)
          });
        }
      }
      return {
        minLabel: i18n.t("config.rangeSlider.from", { ns: APP.name }),
        maxLabel: i18n.t("config.rangeSlider.to", { ns: APP.name }),
        labelFormatter: (value) => i18n.t("format.currency", { value, ns: APP.name }),
        valueFormatter: (value) => `${value == null ? void 0 : value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}`,
        valueParser: (value) => {
          if (typeof value !== "string") {
            return null;
          }
          return Number(value.replace(/\s/g, ""));
        },
        headerDisplayType: "input",
        ...preparedProps
      };
    }
    default:
      return preparedProps;
  }
};
export {
  prepareFilterItemProps
};
